import { motion } from 'framer-motion'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { ISchemaAdminInfo } from '../../../shared/types'
import { registrationSliceActions, selectAdminInfo } from '../../../store/features/registration'
import IntlTelInput from '../../organisms/IntlTelInput'
import TextInput from '../../organisms/TextInput'
import ValidatedForm from '../../organisms/ValidatedForm'
import { ValidatedPrimaryButton } from '../../organisms/ValidationButton'


export default function AdminInfo() {

    const dispatch = useDispatch()
    const adminInfo = useSelector(selectAdminInfo)

    const initialValues= {

        first_name: adminInfo.first_name,
        last_name: adminInfo.last_name,
        email: adminInfo.email,
        password: adminInfo.password,
        phone: adminInfo.phone
    
    }
    
    const validationSchema = Yup.object().shape({
        first_name: Yup.string().required().min(1).max(20).label("first_name"),
        last_name: Yup.string().required().min(1).max(40).label("last_name"),
        email: Yup.string().required().email().label("email"),
        phone: Yup.string().required().label("phone"),
        password: Yup.string().required().min(5).max(20).label("password"),
        confirm_password: Yup.string().required().oneOf([Yup.ref('password')]).label("confirm_password")
    })

    const submit = (adminInfo:ISchemaAdminInfo)=>{
        
        dispatch(registrationSliceActions.setAdminInfo(adminInfo))
        dispatch(registrationSliceActions.setCurrentPage(1))
    }

    return (
        <motion.div
            className="w-full h-92.5 md:mt-80 "
            exit={{
                x: "-100px"
            }}
            initial={{
                opacity: 0,
                x: "100px"
            }}
            animate={{
                opacity: 1,
                x: 0
            }}
        >
            
            <div
                className="absolute top-1/2 left-1/2 translate-x-neg-1/2 translate-y-neg-1/2 bg-white py-8 px-12 shadow-2xl rounded"
            >
                <form>
                    <ValidatedForm
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={submit}
                    >
                        <div className='sm:w-72'>
                            <header className='leading-7 text-center'>
                                <h2 className='font-semibold text-2xl text-primary'>Personal Information</h2>
                                <span className="text-graphite" >Please tell us a bit about yourself to begin the process</span>
                            </header>
                            
                        </div>

                        <div
                            className="my-12 w-full"
                        >

                            <div
                                className="flex flex-row my-6 md:flex-col"
                            >
                                <div className="mr-2 w-full last:m-0 md:mr-0 md:mb-4">
                                    <TextInput
                                        name="first_name"
                                        text="First name"
                                        placeholder="first name"
                                        type="text"
                                    />
                                </div>
                                <div className="mr-1 w-full last:m-0">
                                    <TextInput
                                        name="last_name"
                                        text="Last name"
                                        placeholder="last name"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div
                                className="flex flex-row my-6 md:flex-col"
                            >
                                <div className="mr-2 w-full last:m-0 md:mr-0 md:mb-4">
                                    <TextInput
                                        name="email"
                                        text="Email"
                                        placeholder="email"
                                        type="email"
                                    />
                                </div>
                                <div className="mr-1 w-full last:m-0">
                                    <IntlTelInput 
                                        name="phone"
                                        text="Phone"
                                        preferredCountries={["gh", "ng", "ke","us", "gb"]}
                                    />
                                </div>
                            </div>

                            <div
                                className="flex flex-row justify-between my-6 md:flex-col"
                            >
                                <div className="mr-2 w-full last:m-0 md:mr-0 md:mb-4">
                                    <TextInput
                                        name="password"
                                        text="Password"
                                        placeholder="enter your password"
                                        type="password"
                                    />
                                </div>
                                <div className="mr-1 last:m-0 w-full">
                                    <TextInput
                                        name="confirm_password"
                                        text="Confirm Password"
                                        placeholder="confirm password"
                                        type="password"
                                    />
                                </div>
                            </div>

                            

                                
                            
                        </div>
                        <ValidatedPrimaryButton
                            loading={false}
                        >
                            Register
                        </ValidatedPrimaryButton>
                    </ValidatedForm>
                </form>

            </div>

        </motion.div>
    )
}
